import { API } from 'aws-amplify';

export const callLLMChat = async (messageId: string, sessionId: string, user: any, prompt: string, previousConversations: any[], additionalMetadata: any): Promise<string> => {

    console.log("callGenerativeSQLAI called");

    const input = {
        "action": "chat",
        "message_id": messageId,
        "session_id": sessionId,
        "user_id": user?.username || "unknown",
        "prompt": prompt,
        "previous_conversations": previousConversations.filter(msg => msg.role !== "tool"),
        "metadata": additionalMetadata,
    };

    try {
        const response: any = await API.post("EDPlatformLLMAPI", "/chat", {
            body: input,
        });
        console.log('callLLMChat response', response);
        return response;
    } catch (err: any) {
        console.error(err)
        console.log("Error when calling callLLMChat");
        return "";
    }
}

export const callLLMDashboardStreamable = async (sessionId: string, inputObj: any): Promise<string> => {

    console.log("callLLMDashboardStreamable called");

    const input = {
        "action": "dashboard",
        "arguments": {
            "input": {
                ...inputObj,
                "session_id": sessionId,
            },
        },
    };

    try {
        const response: any = await API.post("EDPlatformLLMAPI", "/chat", {
            body: input,
        });
        console.log('callLLMDashboardStreamable response', response);
        return response;
    } catch (err: any) {
        console.error(err)
        console.log("Error when calling callLLMDashboardStreamable");
        return "";
    }
}

export const callLLMFeedback = async (messageId: string, feedback: string, feedbackDetails: string): Promise<string> => {

    console.log("callLLMFeedback called");

    const input = {
        "action": "feedback",
        "message_id": messageId,
        "feedback": feedback,
        "feedback_details": feedbackDetails,
    };

    try {
        const response: any = await API.post("EDPlatformLLMAPI", "/chat", {
            body: input,
        });
        console.log('callLLMChat response', response);
        return response;
    } catch (err: any) {
        console.error(err)
        console.log("Error when calling callLLMChat");
        return "";
    }
}

/**
 * Call ping when you need to cold-start the Lambda
 */
export const callLLMPing = async (): Promise<string> => {

    console.log("callPing called");

    const input = {
        "action": "ping",
    };

    try {
        const response: any = await API.post("EDPlatformLLMAPI", "/chat", {
            body: input,
        });
        console.log('callPing response', response);
        return response;
    } catch (err: any) {
        console.error(err)
        console.log("Error when calling callPing");
        return "";
    }
}

/**
 * Get list of past conversations for the current user
 */
export const callLLMGetConversations = async (user: any): Promise<any[]> => {
    console.log("callLLMGetConversations called");

    const input = {
        "action": "get_conversations",
        "user_id": user?.username || "unknown",
    };

    try {
        const response: any = await API.post("EDPlatformLLMAPI", "/conversations", {
            body: input,
        });
        console.log('callLLMGetConversations response', response);
        return response.conversations || [];
    } catch (err: any) {
        console.error(err);
        console.log("Error when calling callLLMGetConversations");
        return [];
    }
}

/**
 * Get messages for a specific conversation session
 */
export const callLLMGetConversationMessages = async (sessionId: string): Promise<any[]> => {
    console.log("callLLMGetConversationMessages called");

    const input = {
        "action": "get_conversation_messages",
        "session_id": sessionId,
    };

    try {
        const response: any = await API.post("EDPlatformLLMAPI", "/conversations", {
            body: input,
        });
        console.log('callLLMGetConversationMessages response', response);
        return response.messages || [];
    } catch (err: any) {
        console.error(err);
        console.log("Error when calling callLLMGetConversationMessages");
        return [];
    }
}

/**
 * Delete a conversation
 */
export const callLLMDeleteConversation = async (sessionId: string): Promise<boolean> => {
    console.log("callLLMDeleteConversation called");

    const input = {
        "action": "delete_conversation",
        "session_id": sessionId,
    };

    try {
        const response: any = await API.post("EDPlatformLLMAPI", "/conversations", {
            body: input,
        });
        console.log('callLLMDeleteConversation response', response);
        return response.success || false;
    } catch (err: any) {
        console.error(err);
        console.log("Error when calling callLLMDeleteConversation");
        return false;
    }
}
